<template>
  <div class="Schedules lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Schedules-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Schedules-main lxn-pos-rel">
      <div class="Schedules-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox v-for="(hubSchedules, index) in hubsSchedules" :key="index" :titleBgColor="titleBgColor(index)" bgColor="#ECECEC">
          <template v-slot:title>
            {{hubName(hubSchedules.hubUUID)}}
          </template>
          <template v-slot:body>
            <div v-if="hubSchedules.schedules.length == 0 && hubSchedules.error" class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Schedules_loadError}}
            </div>
            <div v-else-if="hubSchedules.schedules.length == 0"  class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Schedules_noSchedule}}
            </div>
            <div @click="editSchedule(schedule)" class="Schedules-wrapper-schedule lxn-margin-auto lxn-border-round lxn-overflow-hidden lxn-pos-rel lxn-cursor-pointer" v-for="(schedule, index2) in hubSchedules.schedules" :key="index+'-'+index2">
              <div class="Schedules-schedule-color lxn-h100" :class="[$store.getters.language.floatClass]" :style="scheduleColor(schedule.color)">
              </div>
              <div class="Schedules-schedule-wrapper-fields lxn-h100" :class="[$store.getters.language.floatClass]">
                <div class="Schedules-schedule-wrapper-left lxn-h100" :class="[$store.getters.language.floatClass]">
                  <div v-if="!schedule.hasSecondary" class="Schedules-schedule-wrapper-time lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.floatClass]">
                    {{getSceduleTime(schedule.timeEvent)}} 
                  </div>
                  <div v-else class="Schedules-schedule-wrapper-time lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.floatClass]">
                    {{getSceduleTime(schedule.timeEvent)}} - {{getSceduleTime(secondaryScheduleTimeEvent(schedule))}} 
                  </div>
                  <div class="Schedules-schedule-wrapper-name lxn-w100 lxn-small-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.floatClass]">
                    {{schedule.name}}
                  </div>
                  <div class="Schedules-schedule-wrapper-days lxn-w100 lxn-small-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.floatClass]">
                    {{getScheduleDays(schedule.timeEvent)}}
                  </div>
                </div>
                <div class="Schedules-schedule-wrapper-switch" :class="[$store.getters.language.floatClass]">
                  <SingleSwitch @switchClicked.stop="toggleSchedule(schedule)" :state="schedule.active?'on':'off'" :bgColorOn="scheduleButtonColor(schedule.color)" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
                </div>
              </div>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="Schedules-button lxn-margin-auto lxn-w100">
        <CustomButton @click="addSchedule" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.Schedules_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import SingleSwitch from '@/components/SingleSwitch.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import luxinLanguages from '@/statics/language.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

export default {
  name: 'Schedules',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    SingleSwitch
  },
  data: function () {
    return {
      hubsSchedules: [],
    }
  },
  mounted: async function () {
    if(this.$store.state.hubs.length == 0){
      alert(this.$store.getters.language.texts.Schedules_alert);
      this.$router.push('/home/dashboard/');
    }else{
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        this.$store.commit('setAppBusy', true);
        var hub = this.$store.state.hubs[i];
        this.hubsSchedules.push({
          hubUUID: hub.uuid,
          error: false,
          schedules: [],
        });
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        try {
          var fetchedSchedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
          var targetHubIndex = fetchedSchedulesList.hubIndex;
          fetchedSchedulesList = fetchedSchedulesList.body.bodyContent.schedulesList;

          var instructionList = await this.$store.dispatch('readHubInstructions', {messagingHook: messagingHook,hubUUID: hub.uuid,});
          instructionList = instructionList.body.bodyContent.instructionList;

          var imitatorsList = await this.$store.dispatch('getUplinkImitators', {messagingHook: messagingHook,hubUUID: hub.uuid,});
          imitatorsList = imitatorsList.body.bodyContent.imitatorsList;

          var eventMasks = await this.$store.dispatch('getEventMasks', {messagingHook: messagingHook,hubUUID: hub.uuid,});
          eventMasks = eventMasks.body.bodyContent.maskList;

          var hubWatches = await this.$store.dispatch('readHubWatches', {messagingHook: messagingHook,hubUUID: hub.uuid,});
          hubWatches = hubWatches.body.bodyContent.watchList;

          // if (hubWatches != undefined) {
          //   this.$store.commit('setAppBusy', false);
          //   throw "wait for me";
          // }

          instructionList.forEach(async instruction => {
            if(instruction.eventIdToWatch >> 8 == CONFIGS.SCHEDULE_EVENT_ID_PREFIX){
              var savedSchedule = this.$store.getters.getScheduleForHubByEventId(this.$store.state.hubs[targetHubIndex].uuid ,instruction.eventIdToWatch);
              if(savedSchedule != -1){
                if(JSON.stringify(savedSchedule.scheduleCommand) != JSON.stringify(instruction.commandToSend)){
                  this.$store.commit('deleteSchedule', savedSchedule);
                  savedSchedule = -1;
                }
              }
              var hubSchedule = fetchedSchedulesList.find(schedule => schedule.eventId == instruction.eventIdToWatch);
              var isMasked = eventMasks.find(eventMask => eventMask.eventId == instruction.eventIdToWatch);
              if(isMasked){
                isMasked = true;
              }else{
                isMasked = false;
              }

              if(hubSchedule){
                if(savedSchedule != -1){
                  this.$store.commit('updateScheduleTimeEvent', {
                    scheduleIndex: savedSchedule.index,
                    timeEvent: hubSchedule.timeEvent
                  })
                  this.$store.commit('updateScheduleActive', {
                    scheduleIndex: savedSchedule.index,
                    active: !isMasked,
                  });
                }else{
                  this.$store.commit('addSchedule', {
                      name: this.$store.getters.language.texts.Schedules_schedule,
                      color: 0,
                      hubUUID: this.$store.state.hubs[targetHubIndex].uuid,
                      eventIdToWatch: instruction.eventIdToWatch,
                      timeEvent: {
                        dateStamp: hubSchedule.timeEvent.dateStamp,
                        timeStamp: hubSchedule.timeEvent.timeStamp,
                        repeatMask: hubSchedule.timeEvent.repeatMask,
                      },
                      scheduleCommand: instruction.commandToSend,
                      active: !isMasked,
                  });
                }
              }else{
                await this.$store.dispatch('deleteHubInstructionsByEventId', {
                  messagingHook: messagingHook,
                  hubUUID: hub.uuid,
                  bodyContent: {
                    instructionsList: [
                      {
                        eventIdToWatch: instruction.eventIdToWatch
                      }
                    ]
                  }
                })
              }
            }
          });
          imitatorsList.forEach(async imitator => {
            if(imitator.eventIdToWatch >> 8 == CONFIGS.SCHEDULE_EVENT_ID_PREFIX){
              var savedSchedule = this.$store.getters.getScheduleForHubByEventId(this.$store.state.hubs[targetHubIndex].uuid ,imitator.eventIdToWatch);
              if(savedSchedule != -1){
                if(JSON.stringify(savedSchedule.scheduleCommand) != JSON.stringify(imitator.commandToSend)){
                  this.$store.commit('deleteSchedule', savedSchedule);
                  savedSchedule = -1;
                }
              }
              var hubSchedule = fetchedSchedulesList.find(schedule => parseInt(schedule.eventId) == parseInt(imitator.eventIdToWatch));
              var isMasked = eventMasks.find(eventMask => eventMask.eventId == imitator.eventIdToWatch);
              if(isMasked){
                isMasked = true;
              }else{
                isMasked = false;
              }

              if(hubSchedule){
                // if (hubWatches != undefined){
                //   throw "wait wait wait!";
                // }
                if(savedSchedule != -1){
                  this.$store.commit('updateScheduleTimeEvent', {
                    scheduleIndex: savedSchedule.index,
                    timeEvent: hubSchedule.timeEvent
                  })
                  this.$store.commit('updateScheduleActive', {
                    scheduleIndex: savedSchedule.index,
                    active: !isMasked,
                  });
                }else{
                  this.$store.commit('addSchedule', {
                      name: this.$store.getters.language.texts.Schedules_schedule,
                      color: 0,
                      hubUUID: this.$store.state.hubs[targetHubIndex].uuid,
                      eventIdToWatch: imitator.eventIdToWatch,
                      timeEvent: {
                        dateStamp: hubSchedule.timeEvent.dateStamp,
                        timeStamp: hubSchedule.timeEvent.timeStamp,
                        repeatMask: hubSchedule.timeEvent.repeatMask,
                      },
                      scheduleCommand: imitator.commandToSend,
                      active: !isMasked,
                  });
                }
              }else{
                //TODO: this is a premature schedule. should delete the orphaned imitator.

                var newImitatorsList = [];
                for(i = 0; i < imitatorsList.length; i++){
                  if(imitatorsList[i].eventIdToWatch !== imitator.eventIdToWatch){
                    newImitatorsList.push(imitatorsList[i]);
                  }
                }
                await this.$store.dispatch('setUplinkImitator', {
                  messagingHook: messagingHook,
                  hubUUID: hub.uuid,
                  imitatorsList: newImitatorsList,
                })

              }
            }
          });
          var tempSchedules = [];
          this.$store.state.schedules.forEach( (schedule,index) => {
            if(this.$store.state.hubs[targetHubIndex].uuid == schedule.hubUUID){
              var foundInstruction = instructionList.find(instruction => {
                return instruction.eventIdToWatch == schedule.eventIdToWatch
              });
              if(!foundInstruction){
                foundInstruction = imitatorsList.find(imitator => {
                  return imitator.eventIdToWatch == schedule.eventIdToWatch
                });
              }
              if(foundInstruction){
                schedule.index = index;
                if (schedule.type != 2){
                  tempSchedules.push(schedule);
                }else if (schedule.type == 2 && schedule.hasSecondary){
                  tempSchedules.push(schedule);
                }
                
              }else{
                this.$store.commit('deleteSchedule', index);
              }
            }
          });
          tempSchedules.sort( (schedule1, schedule2) => {
            var timeString1 = this.getSceduleTime(schedule1.timeEvent);
            var timeString2 = this.getSceduleTime(schedule2.timeEvent);

            if(timeString1 > timeString2){
              return 1;
            }else{
              return -1;
            }
          })
          this.hubsSchedules[targetHubIndex].schedules = tempSchedules;
          this.$store.commit('saveState');
          this.$store.commit('setAppBusy', false);
        }
        catch (response) {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
          // this.hubsSchedules[response.hubIndex].error = true;
          this.$store.commit('setAppBusy', false);
        }
      }
    }
  },
  watch: {
  },
  computed: {
    trashIconStyle: function () {
      if(luxinLanguages[this.$store.state.language].isRTL){
        return "left: 10px;";
      }else{
        return "right: 10px;";
      }
    },
  },
  methods: {
    secondaryScheduleTimeEvent: function(schedule) {
      let primaryScheduleId = schedule.eventIdToWatch & 0xFF
      let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
      let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(schedule.hubUUID, secondaryScheduleEventId);
      return secondarySchedule.timeEvent
    },
    goBack: function () {
      this.$router.push('/home/dashboard/');
    },
    titleBgColor: function (index) {
      return this.$store.state.themeMainColors[this.$store.state.hubs[index].color];
    },
    addSchedule: function () {
      this.$router.push('/addSchedules/');
    },
    updaete_schedule_dateTimeStamp: async function (schedule, fetchedSchedulesList, messagingHook, hubUUID) {
      var scheduleDateTimeStamp = schedule.timeEvent.dateStamp * 86400000 + schedule.timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var currentEpochTime = Date.now();

      var targetDateStamp = 0;
      var targetTimeStamp = 0;

      var localDateObject = new Date();
      var repeatMask = 0;

      var userSelectedLocalTimeStamp = (hours*60 + minutes) * 60000;
      var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
      var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
      
      if(timeStampDiff < 0){
        timeStampDiff += 86400000;
      }
      var userSelectedDateTimeStamp = currentEpochTime + timeStampDiff;
      targetDateStamp = Math.floor(userSelectedDateTimeStamp / 86400000);
      targetTimeStamp = userSelectedDateTimeStamp % 86400000;
      repeatMask = CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL;

      fetchedSchedulesList.find((scheduleOnHub, scheduleIndex) => {
        if(scheduleOnHub.eventId == schedule.eventIdToWatch){
          fetchedSchedulesList[scheduleIndex].timeEvent = {
            dateStamp: targetDateStamp,
            timeStamp: targetTimeStamp,
            repeatMask: repeatMask,
          }
          return true;
        }
        return false;
      })
      await this.$store.dispatch('setHubSchedules', {
        messagingHook: messagingHook,
        hubUUID: hubUUID,
        bodyContent: {
          schedulesList: fetchedSchedulesList,
        }
      });
      this.$store.commit('updateScheduleTimeEvent', {
        scheduleIndex: schedule.index,
        timeEvent: {
          dateStamp: targetDateStamp,
          timeStamp: targetTimeStamp,
          repeatMask: repeatMask,
        }
      })
    },
    isTriggerTimeHasPassed: function(schedule) {
      var scheduleDateTimeStamp = schedule.timeEvent.dateStamp * 86400000 + schedule.timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var localDateObject = new Date();

      var userSelectedLocalTimeStamp = (hours*60 + minutes) * 60000;
      var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
      var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
      
      if(timeStampDiff < 0){
        return true;
      }
      return false;
    },
    toggleSchedule: async function (schedule) {
      this.$store.commit('setAppBusy', true);
      var hub = this.$store.getters.getHubByUUID(schedule.hubUUID);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: schedule.hubUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      try {
        var fetchedSchedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
        fetchedSchedulesList = fetchedSchedulesList.body.bodyContent.schedulesList;
        var hubSchedule = fetchedSchedulesList.find(hubSchedule => hubSchedule.eventId == schedule.eventIdToWatch);

        if(hubSchedule){
          // reverse the schedule mask 
          let  primaryTriggertimeHasPassed = false;
          let  secondaryTriggerHasPassed = false;
          if(hubSchedule.timeEvent.repeatMask == CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL){
            primaryTriggertimeHasPassed = this.isTriggerTimeHasPassed(schedule);
            this.updaete_schedule_dateTimeStamp(schedule, fetchedSchedulesList, messagingHook, hub.uuid);
            if (schedule.hasSecondary) {
              let primaryScheduleId = schedule.eventIdToWatch & 0xFF
              let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
              let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
              secondaryTriggerHasPassed =  this.isTriggerTimeHasPassed(secondarySchedule);
              this.updaete_schedule_dateTimeStamp(secondarySchedule, fetchedSchedulesList, messagingHook, hub.uuid);
            }
          }

          var maskList = [{
            eventId: schedule.eventIdToWatch,
            isMasked: schedule.active,
          }];
          if (schedule.type == 2 && schedule.hasSecondary){
            // reverse the secondary schedule mask and masks of the schedule command
            let primaryScheduleId = schedule.eventIdToWatch & 0xFF
            let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
            let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
            maskList.push({
              eventId: secondarySchedule.eventIdToWatch,
              isMasked: maskList[0].isMasked,
            });
            for (let k=0; k < schedule.commandMaskList.length; k++) {
              let mask = schedule.commandMaskList[k];
              if (this.$store.state.schedules[secondarySchedule.index].active) {
                // if the schedule currently is active and we want to disable it, then we disable the notification eventId also, so completely 
                // disable the notification, but if the schedule is not active right now and we want to enable it ,we have to check if we are in
                // the scheduled time to disable the mask
                maskList.push({
                  eventId: mask.eventId,
                  isMasked: true
                }) 
              } else {
              
                if (mask.isMasked == true) { // if the primary mask is true so the secondary mask is responsible for activating the notification
                  if (secondaryTriggerHasPassed) {
                    maskList.push({
                      eventId: mask.eventId,
                      isMasked: false
                    })      
                  }
                } else {
                  if (primaryTriggertimeHasPassed && !secondaryTriggerHasPassed) {
                    maskList.push({
                      eventId: mask.eventId,
                      isMasked: false
                    })      
                  }
                }
              }
            }
          }
          await this.$store.dispatch('setEventMasks', {
            messagingHook: messagingHook,
            hubUUID: hub.uuid,
            bodyContent: {
              maskList: maskList
            }
          });
          let newState = !schedule.active;
          this.$store.commit('updateScheduleActive', {
            scheduleIndex: schedule.index,
            active: newState,
          });
          if (schedule.type == 2 &&  schedule.hasSecondary){
            let primaryScheduleId = schedule.eventIdToWatch & 0xFF
            let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
            let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
            this.$store.commit('updateScheduleActive', {
              scheduleIndex: secondarySchedule.index,
              active: newState,
            });
          }
        }
        this.$store.commit('saveState');
        this.$store.commit('setAppBusy', false);
      }
      catch (response) {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      }
    },
    hubName: function (hubUUID) {
      var hub = this.$store.getters.getHubByUUID(hubUUID);
      return hub.name
    },
    scheduleColor: function (colorIndex) {
      return "background-color: " + this.$store.state.themeMainColors[colorIndex] + ";";
    },
    scheduleButtonColor: function (colorIndex) {
      return this.$store.state.themeMainColors[colorIndex];
    },
    openCommand: function (hubUUID, eventId) {
      this.$router.push('/showInstruction/' + hubUUID + "/" + eventId);
    },
    getSceduleTime: function (timeEvent) {
      var scheduleDateTimeStamp = timeEvent.dateStamp * 86400000 + timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();
      hours = ("00" + hours).slice(-2);
      minutes = ("00" + minutes).slice(-2);
      return hours + ":" + minutes;
    },
    getScheduleDays: function (timeEvent) {
      var scheduleDateTimeStamp = timeEvent.dateStamp * 86400000 + timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var weekDaysOffset = 0;
      var timeZoneOffset = new Date().getTimezoneOffset();

      var timeStampInMinutes = hours*60 + minutes + timeZoneOffset;

      if(timeStampInMinutes < 0){
        weekDaysOffset = 1;
      }else if(timeStampInMinutes >= 24*60){
        weekDaysOffset = -1;
      }

      var selectedDays = '';
      if((timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL) != 0){
        return '';
      }
      var daysInOrder = [6, 0, 1, 2, 3, 4, 5];
      if(weekDaysOffset == 1){
        daysInOrder = [5, 6, 0, 1, 2, 3, 4];
      }else if(weekDaysOffset == -1){
        daysInOrder = [0, 1, 2, 3, 4, 5, 6];
      }
      var everyDay = true;
      for(var i = 0; i < 7; i++){
        if((timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_WEEKDAYS[daysInOrder[i]]) != 0){
          var weekDayWithOffset = (((i + weekDaysOffset) % 7) + 7) % 7;
          selectedDays += ' ' + this.$store.getters.language.texts.weekDays[daysInOrder[weekDayWithOffset]]
        }else{
          everyDay = false;
        }
      }
      if(everyDay){
        return this.$store.getters.language.texts.Schedules_everyDay
      }else{
        return selectedDays.substring(1);
      }
    },
    editSchedule: function (schedule) {
      this.$router.push('/editSchedule/' + schedule.index);
    }
  }
}
</script>

<style>
  .Schedules-topCurve-wrapper {
    height: 200px;
  }
  .Schedules-main {
    z-index: 2;
  }
  .Schedules-main-wrapper {
    min-height: 150px;
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .Schedules-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .Schedules-wrapper-schedule {
    width: calc(100% - 14px);
    height: 70px;
    background-color: #FFFFFF;
    margin-top: 14px;
  }
  .Schedules-wrapper-schedule:first-child {
    margin-top: 0px;
  }
  .Schedules-schedule-color {
    width: 10px;
  }
  .Schedules-schedule-wrapper-fields {
    width: calc(100% - 10px);
    padding: 10px;
    padding-bottom: 0;
  }
  .Schedules-schedule-wrapper-switch {
    width: 80px;
    margin-top: 10px;
  }
  .Schedules-schedule-wrapper-left {
    width: calc(100% - 80px);
  }
  .Schedules-schedule-wrapper-time {
    height: 25px;
    font-size: 20px;
  }
  .Schedules-schedule-wrapper-name {
    height: 20px;
    font-size: 11px;
    line-height: 20px;
  }
  .Schedules-schedule-wrapper-days {
    height: 12px;
    font-size: 8px;
    line-height: 12px;
  }
</style>
